import { useQuery } from '@tanstack/react-query';

import { queryFn } from './queryFn';

const QUERY_KEY = 'DEMO_PORTFOLIO' as const;

export function useDemoPortfolio({ id }: { id: string }) {
  const { data, status } = useQuery({
    enabled: id.length > 0,
    queryKey: [QUERY_KEY, id],
    queryFn,
    retry: 1,
    staleTime: 3600000,
  });

  return {
    data,
    status,
  };
}
